/* eslint-disable */

import React, { useState } from 'react';
import { func, string, bool } from 'prop-types';
import { useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import groupBy from 'lodash/groupBy';
import Spinner from 'Shared/components/Spinner';
import Recommendation from './components/Recommendation/Recommendation';
import './PreviewModal.scss';

function PreviewModal({ onToggle, isOpen, displayName, onDoneClick }) {
  const {
    loading,
    requested_users: requestedUsers,
    received_users: receivedUsers,
    data: recommendationPreviews,
  } = useSelector(state => state.recommendation_previews);

  const recommendationPreviewsRequestsPending = requestedUsers && requestedUsers.length !== receivedUsers.length;
  const [previewFilterText, setPreviewFilterText] = useState('');
  const recommendationPreviewsFiltered = recommendationPreviews.filter(({ user: { person: { identifier } } }) =>
    identifier.toLowerCase().includes(previewFilterText.toLowerCase())
  );

  const recommendationPreviewsGroupedByUserIdentifier = Object.entries(
    groupBy(
      recommendationPreviewsFiltered,
      ({
        user: {
          person: { identifier },
        },
      }) => identifier
    )
  );

  const handleChangeFilterText = event => setPreviewFilterText(event.currentTarget.value);

  const isLoading = loading || recommendationPreviewsRequestsPending;
  const noRecommendations = !isLoading && recommendationPreviews.length === 0;

  return (
    <Modal toggle={onToggle} className="preview" centered isOpen={isOpen}>
      <ModalHeader className="preview-header ml-2" toggle={onToggle}>
        {`Preview: ${displayName} Nudges`}
      </ModalHeader>
      <ModalBody>
        {!isLoading && !noRecommendations && (
          <>
            <div className="preview-label ml-2 mb-1">Filter By User</div>
            <input
              type="text"
              className="form-control preview-input-filter ml-2"
              placeholder="Filter by user"
              onChange={handleChangeFilterText}
            />
          </>
        )}

        {noRecommendations && (
          <div className="d-flex justify-content-center mt-4">
            <p>No recommendations generated</p>
          </div>
        )}

        {isLoading && (
          <div className="d-flex justify-content-center mt-4">
            <Spinner activeIf />
          </div>
        )}

        {!loading &&
          recommendationPreviewsGroupedByUserIdentifier.map(([userIdentifier, recommendations]) => (
            <div className="ml-2 mt-4 mb-5" key={userIdentifier}>
              <h4 className="preview-user-label">{`${userIdentifier}'s Nudges`}</h4>
              <hr className="preview-line" />
              {recommendations &&
                recommendations.map(recommendation => (
                  <div key={recommendation.description + recommendation.title}>
                    <Recommendation
                      callExternalAPI={() => {
                        alert('Action buttons are disabled in Preview mode.');
                      }}
                      clickedLink={() => {}}
                      clickedDismiss={() => {}}
                      recommendation={recommendation}
                    />
                    <p />
                  </div>
                ))}
            </div>
          ))}
      </ModalBody>
      <ModalFooter>
        <div className="d-flex justify-content-end mt-4">
          <button className="btn btn-secondary preview-button mr-3" type="button" onClick={onToggle}>
            Cancel
          </button>
          <button className="btn btn-primary preview-button" type="button" onClick={onDoneClick}>
            Done
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

PreviewModal.propTypes = {
  onToggle: func.isRequired,
  isOpen: bool.isRequired,
  displayName: string.isRequired,
  onDoneClick: func.isRequired,
};

export default PreviewModal;
